import {cart, lineItem, toggle} from './shopifyOptions.js';

window.addEventListener('load', function() {
    // Shopify

    window.initShopify = function() {
        console.log("Shopify init")

        var client = ShopifyBuy.buildClient({
            domain: 'selftitled-shoerts.myshopify.com',
            storefrontAccessToken: process.env.TOKEN
        });

        ShopifyBuy.UI.onReady(client).then(function (ui) {
            console.log(cart)

            ui.createComponent('cart', {
                options: {
                    cart: cart, 
                    lineItem: lineItem,
                    toggle: toggle
                }
            })
        });

        window.shopifyInitialized = true
    }

    // if (Consent.shopify.consent) initShopify()
    initShopify()

});